import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Truck, Eye, EyeOff, AlertCircle } from 'lucide-react';

export default function CourierLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(email, password, 'courier');
      navigate('/kurir');
    } catch (err) {
      setError('Email atau password salah. Hubungi admin jika lupa password.');
    }
    setLoading(false);
  };

  return (
    <div style={{
      paddingTop: 64, minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f1a0f 0%, #14532d 50%, #166534 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '80px 1rem 2rem'
    }}>
      {/* Decorative elements */}
      <div style={{ position: 'absolute', top: '20%', left: '10%', width: 200, height: 200, borderRadius: '50%', background: 'rgba(251,191,36,0.05)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: '15%', right: '8%', width: 300, height: 300, borderRadius: '50%', background: 'rgba(255,255,255,0.02)', pointerEvents: 'none' }} />

      <div style={{ width: '100%', maxWidth: 420, position: 'relative' }}>
        {/* Card */}
        <div style={{ background: '#fff', borderRadius: 24, padding: '2.5rem', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
          {/* Icon */}
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <div style={{
              width: 72, height: 72, borderRadius: 20, margin: '0 auto 14px',
              background: 'linear-gradient(135deg, #15803d, #16a34a)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 8px 24px rgba(21,128,61,0.35)'
            }}>
              <Truck size={32} color="#fff" />
            </div>
            <h1 style={{ fontSize: '1.5rem', color: 'var(--green-900)', marginBottom: 4 }}>Portal Kurir</h1>
            <p style={{ color: 'var(--text-muted)', fontSize: 14 }}>Masuk untuk memulai tugas pengantaran daging qurban</p>
          </div>

          {error && (
            <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start', background: '#fee2e2', border: '1px solid #fca5a5', borderRadius: 10, padding: '10px 14px', marginBottom: '1.25rem', color: '#991b1b', fontSize: 13 }}>
              <AlertCircle size={16} style={{ flex: 'none', marginTop: 1 }} /> {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Email Kurir</label>
              <input type="email" className="form-input" placeholder="kurir@qurban.id"
                value={email} onChange={e => setEmail(e.target.value)} required />
            </div>
            <div className="form-group">
              <label className="form-label">Password</label>
              <div style={{ position: 'relative' }}>
                <input type={showPass ? 'text' : 'password'} className="form-input" placeholder="••••••••"
                  value={password} onChange={e => setPassword(e.target.value)} required style={{ paddingRight: 40 }} />
                <button type="button" onClick={() => setShowPass(!showPass)}
                  style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-muted)' }}>
                  {showPass ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            <button type="submit" disabled={loading} style={{
              width: '100%', padding: '13px', marginTop: 8, borderRadius: 12, border: 'none',
              background: loading ? '#86efac' : 'linear-gradient(135deg, #15803d, #16a34a)',
              color: '#fff', fontWeight: 700, fontSize: 15, cursor: loading ? 'not-allowed' : 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
              transition: 'all 0.2s', boxShadow: '0 4px 16px rgba(21,128,61,0.3)'
            }}>
              <Truck size={18} /> {loading ? 'Memverifikasi...' : 'Masuk sebagai Kurir'}
            </button>
          </form>

          <div style={{ marginTop: '1.5rem', padding: '12px 16px', background: 'var(--green-50)', borderRadius: 10, fontSize: 13, color: 'var(--text-muted)', textAlign: 'center' }}>
            Lupa password? Hubungi admin qurban untuk reset akun kamu.
          </div>
        </div>
      </div>
    </div>
  );
}
